//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Typography, TextField, Button, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
//MUI ICONS
import { EditDocument } from '@mui/icons-material';
//STYLES
import styles from '../../../module_css/formsCatalogs.module.css';
//PICTURES
import imgUpdate from '../../../assets/svg/update.svg';
//API CONTROLLER
import ApiController from '../../../controllers/api';
//CUSTOM COMPONENTS
import CustomBackdrop from '../../CustomBackdrop';
//OTHERS
import Swal from 'sweetalert2';

const ERROR_MESSAGES = {
  required:  "EL CAMPO ES OBLIGATORIO",
  invalid:   "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO"
};
const PROPERTIES_ENTRIES = {
    abrev:{
      required: true,
      pattern: /^[0-9]\d*$/
    },
    descripcionCargo:{
      required: true,
      pattern: /^[A-ZÁÉÍÓÚÜÑ0-9 .,\'"()\-\:;\/]+$/,
      minLength: 10,
      maxLength: 150
    },
    superiorJeraquico :{
      required:true,
      pattern: /^[0-9]\d*$/
    }
}

export default function FormEditArea ({ id = null, handleClose, refreshArea }){
  const [constants, setConstants] = React.useState({
    grades:[],
    superiorJeraquico:[],
    edificioArea: []
  });
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [data, setData] = React.useState({
    nombre: "",
    responsable: "",
    codigo: "",
    abrev: 0,
    descripcionCargo: "",
    superiorJeraquico: 0,
    edificioArea: 0
  });
  const [errors, setErrors] = React.useState({
    abrev: [],
    descripcionCargo: [],
    superiorJeraquico: []
  });
  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);

  const getFormData = async (id) => await apiInstance.get(`/area/${id}`);
  const getConstants = async () => await apiInstance.get(`/area/constants/`);
  const updateData = async (data) => await apiInstance.put(`/area/${id}`,data);

  const handleChange = (e) => {//CONTROLA LAS ENTRADAS DE LOS INPUTS
    const { name, value } = e.target;
    if(['abrev', 'descripcionCargo', 'superiorJeraquico'].includes(name))
    setData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const responseFormData = await getFormData(id);
      const responseConstants = await getConstants();
     if(!responseConstants.success || !responseFormData.success){
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERON CARGAR LOS DATOS',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
          });
      handleClose();
      }else if(responseConstants.success && responseFormData.success){
        setConstants({
          grades: responseConstants.data.GRADOS_RESPONSABLES,
          superiorJeraquico: responseConstants.data.AREAS,
          edificioArea: responseConstants.data.EDIFICIOS
        });
        setData({
          nombre: responseFormData.data?.NOMBRE,
          responsable: responseFormData.data?.RESPONSABLE,
          codigo: responseFormData.data?.CODIGO,
          abrev: responseFormData.data?.ABREV,
          descripcionCargo: responseFormData.data?.DESCRIPCION_CARGO,
          superiorJeraquico: responseFormData.data?.SUPERIOR,
          edificioArea: responseFormData.data?.EDIFICIO_AREA
        });
      }
      setOpenBackdrop(false);
    })();
  }, [id]);

  const validateFieldGeneric = (value, options = {}, fieldName) => {
    const errors = [];
    const exemptFields = ['superiorJeraquico', 'abrev'];
    if(!(exemptFields.includes(fieldName) && value===0)){ // SE HACE UNA EXCEPCION DE LOS SELECT
    if (options.required && !value) errors.push({ type: "required" });
    }
    if (value && options.pattern && !options.pattern.test(value)) errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength) errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength) errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = () => {
    const newErrors = {};
    for (const field in PROPERTIES_ENTRIES) {
      newErrors[field] = validateFieldGeneric(data[field], PROPERTIES_ENTRIES[field], field);
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some(fieldErrors => fieldErrors.length > 0);
  };

  const getHelperText = (field) => {
    return errors[field].map(e => "- *" + ERROR_MESSAGES[e.type]).join("\n") || "";
  };

  const buildPayload = (data) => ({
    ABREV: data.abrev,
    DESCRIPCION_CARGO: data.descripcionCargo?.toUpperCase() || null,
    SUPERIOR_JERARQUICO: data.superiorJeraquico && data.superiorJeraquico !== 0 
      ? Number(data.superiorJeraquico) 
      : null
  });

 const handleSubmit = (event) => {
  event.preventDefault();
  if (!validateAllFields()) return;
    Swal.fire({
      title: "ACTUALIZAR ÁREA ⚠️",
      text: "¿ESTAS SEGURO QUE DESEAS ACTUALIZAR ESTA ÁREA?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, ACTUALIZAR",
      confirmButtonColor: "#1a76d2",
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(async (result) => {
      if (result.isConfirmed) {
          const res = await updateData(buildPayload(data));
          if (res.success) {
            Swal.mixin({
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            }).fire({
              icon: "success",
              title: "ÁREA ACTUALIZADA",
              text: "SE ACTUALIZO CORRECTAMENTE"
            });
            handleClose();
            if (refreshArea) refreshArea();
          }else if(!res.success && res.meta.conflictDuplicate){
              Swal.fire({
                title: 'DATOS DUPLICADOS ⚠️',
                icon: 'info',
                html: `<p>ESTOS CAMPOS YA SE ENCUENTRAN REGISTRADOS DENTRO DE LA BASE DE DATOS:</p>
                      ${res.meta.fields.map(f => `<li>${f}</li>`).join("")}`,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }else if(!res.success){
            Swal.fire({
                title: '¡ERROR! ❌',
                icon: 'error',
                text: 'NO SE PUDIERÓN ACTUALIZAR LOS DATOS DEL ÁREA',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }
          handleClose();
          setOpenBackdrop(false);
      }
    });
  };
  return (
    <>
      <CustomBackdrop open={openBackdrop}/>
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgUpdate} alt="Logo" className={styles.logo_form}/>
        <Typography variant="h6" gutterBottom align='center'>ACTUALIZAR INFORMACIÓN DEL ÁREA</Typography>
        
        <TextField
          label="NOMBRE ÁREA"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="nombre"
          value={data.nombre}
          disabled={true}
          helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
        />
        <TextField
          label="CÓDIGO DE ÁREA"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="codigo"
          value={data.codigo}
          disabled={true}
          helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
        />
        <TextField
          label="NOMBRE DE LA TITULAR DEL ÁREA"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="responsable"
          value={data.responsable}
          disabled={true}
          helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
        />
        <FormControl 
        variant="outlined"
        sx={{ mt: 1, mb: 1 }}
        fullWidth
        error={errors.abrev.length > 0}
        >
          <InputLabel id="grado-label">GRADO DEL RESPONSABLE</InputLabel>
          <Select
            labelId="grado-label"
            id="grado-select"
            name="abrev"
            value={data.abrev}
            onChange={handleChange}
            label="GRADO DEL RESPONSABLE"
          >
            {(constants.grades).map((grado) => (
              <MenuItem key={grado.value} value={grado.value}>
                {grado.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
        variant="outlined"
        sx={{ mt: 1, mb: 1 }}
        fullWidth
        error={errors.superiorJeraquico.length > 0}
        >
        <InputLabel id="superiorJeraquico-label">AREA EN JERARQUIA</InputLabel>
        <Select
          labelId="superiorJeraquico-label"
          id="superiorJeraquico-select"
          name="superiorJeraquico"
          value={data.superiorJeraquico}
          onChange={handleChange}
          label="AREA EN JERARQUIA"
        >
           <MenuItem value={0}>NO HAY AREA EN JERARQUIA</MenuItem>
          {(constants.superiorJeraquico || []).map((sj) => (
            <MenuItem key={sj.UUID} value={sj.VALUE}>
              {sj.NOMBRE}
            </MenuItem>
          ))}
        </Select>
        {errors.superiorJeraquico.length > 0 && (
          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.5, display: "block" }}
          >
            {errors.superiorJeraquico.map((e) => "- *" + ERROR_MESSAGES[e.type]).join("\n")}
          </Typography>
        )}
      </FormControl>

        <TextField
          label="EDIFICIO DESIGNADO"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="edificioArea"
          value={constants.edificioArea[data.edificioArea]?.NOMBRE}
          disabled={true}
          InputLabelProps={{ shrink: true }}
          helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
        />

        <TextField
          label="DESCRIPCIÓN DEL CARGO"
          multiline
          rows={3}
          fullWidth
          className={styles.textField_form}
          variant="outlined"
          name="descripcionCargo"
          value={data.descripcionCargo}
          onChange={handleChange}
          error={errors.descripcionCargo.length > 0}
          helperText={getHelperText("descripcionCargo")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />
        <Button
          variant="contained"
          size="large"
          startIcon={<EditDocument />}
          className={styles.button_form}
          type="submit"
          fullWidth
          color='primary'
        >
            ACTUALIZAR
        </Button>
      </form>
    </>
  );
};